import {MouseEvent} from 'react';
import I18n from 'app/i18n';
import {modalConfirm} from 'app/utils/modals/popups';
import {startCasinoGame} from 'app/services/CasinoServices';
import {hideLastPopup} from 'app/utils/modals/ModalsService';
import FreespinInterface from 'app/interfaces/Freespinsinterface';
import {UserBonusesStore} from 'app/store/UserBonusesStore';
import {goToRoute} from 'app/utils';
import {getTableLinkPath} from 'app/utils/link_helper';

export const handleActivateClick = (
    e: MouseEvent<HTMLButtonElement>,
    gameId: string,
    options: { casino_page?: boolean } = {}
): void => {
    e.preventDefault();
    if (options.casino_page) {
        hideLastPopup();
    } else {
        goToRoute(getTableLinkPath('/casino'));
    }
    startCasinoGame(Number(gameId));
};


export const handleCancelClick = (
    e: MouseEvent<HTMLButtonElement>,
    spin: FreespinInterface,
    userBonusesStore: UserBonusesStore
): void => {
    e.preventDefault();
    modalConfirm(
        I18n.t('casino_free_spins.confirm_deactivate', {count: spin.quantity, name: spin.game}),
        () => userBonusesStore.cancelFreeSpin(spin.id)
    );
};

export const getActivateClickHandler = (
    gameId: string,
    options: { casino_page?: boolean } = {}
) => (e: MouseEvent<HTMLButtonElement>): void => handleActivateClick(e, gameId, options);

export const getCancelClickHandler = (
    spin: FreespinInterface,
    userBonusesStore: UserBonusesStore
) => (e: MouseEvent<HTMLButtonElement>): void => handleCancelClick(e, spin, userBonusesStore);
